// Use $ instead of $ without replacing global $
(function ($) {

  function setProductText() {
    setTimeout(function () {
      var text = "All";
      $('body .filter-block  .selectboxit-container #edit-field-product-type-target-idSelectBoxIt #edit-field-product-type-target-idSelectBoxItText').html(text);
      $('body .filter-block  .selectboxit-container #edit-field-product-type-target-idSelectBoxItOptions .selectboxit-option-first .selectboxit-option-anchor').html(text);
      $('.ua-mobile .filter-block  .form-select option:eq(0)').html(text);
    },500);
  }

  $(document).ready(function () {
    setProductText();

    $(".filter-box select").selectBoxIt({
      //hiding first element
      // showFirstOption: false,
      aggressiveChange: true
    });

    setTimeout(function () {
      $("#edit-field-product-type-target-id--t3N6fng2fwI").selectBoxIt({
        //hiding first element
        // showFirstOption: false,
        aggressiveChange: true
      });

      $(".col-two-grid #edit-field-product-type-target-id").selectBoxIt({
        //hiding first element
        // showFirstOption: false,
        aggressiveChange: true
      });
    }, 50);
  });

  $(window).on('load', function () {

    // setTimeout(function () {
    //   $(".html-layout .maxSize1").selectBoxIt({
    //     //hiding first element
    //     // showFirstOption: false,
    //     aggressiveChange: true
    //   });
    //
    //   $(".contact-form .form-outer .col select").selectBoxIt({
    //     //hiding first element
    //     // showFirstOption: false,
    //     aggressiveChange: true
    //   });
    // }, 50);
  });

})(jQuery);